import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
import { SimpleCardFragmentDoc } from '../../fragments/CardFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CardsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortOrder?: Types.InputMaybe<Types.SortOrder>;
  filter?: Types.InputMaybe<Types.CardFilter>;
}>;


export type CardsQueryResult = { readonly __typename: 'Query', readonly cards: { readonly __typename: 'CardConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename: 'CardEdge', readonly cursor: string, readonly node?: { readonly __typename: 'Card', readonly createdAt: any, readonly headline: string, readonly id: string, readonly postCount: number, readonly recipientName: string, readonly senderName?: string | null, readonly status: Types.Status } | null } | null> | null, readonly pageInfo: { readonly __typename: 'PageInfo', readonly endCursor: string, readonly hasNextPage: boolean } } };


export const CardsDocument = gql`
    query Cards($first: Int, $after: String, $sortBy: String, $sortOrder: SortOrder, $filter: CardFilter) {
  cards(
    first: $first
    after: $after
    sortBy: $sortBy
    sortOrder: $sortOrder
    filter: $filter
  ) {
    ... on CardConnection {
      totalCount
      edges {
        ... on CardEdge {
          cursor
          node {
            ... on Card {
              ...SimpleCardFragment
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${SimpleCardFragmentDoc}`;

/**
 * __useCardsQuery__
 *
 * To run a query within a React component, call `useCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCardsQuery(baseOptions?: Apollo.QueryHookOptions<CardsQueryResult, CardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardsQueryResult, CardsQueryVariables>(CardsDocument, options);
      }
export function useCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardsQueryResult, CardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardsQueryResult, CardsQueryVariables>(CardsDocument, options);
        }
export function useCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CardsQueryResult, CardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardsQueryResult, CardsQueryVariables>(CardsDocument, options);
        }
export type CardsQueryHookResult = ReturnType<typeof useCardsQuery>;
export type CardsLazyQueryHookResult = ReturnType<typeof useCardsLazyQuery>;
export type CardsSuspenseQueryHookResult = ReturnType<typeof useCardsSuspenseQuery>;